// Shared open-now / hours-formatting helpers used by HoursDisplay + directory card.
const DAYS_ORDER = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
// JS Date.getDay(): 0 = Sunday … 6 = Saturday
const JS_DAY_TO_KEY = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

const DAY_LABEL = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

export function formatTime(t) {
  if (!t || typeof t !== "string") return "";
  const [hStr, mStr] = t.split(":");
  const h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10);
  if (isNaN(h) || isNaN(m)) return t;
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${m.toString().padStart(2, "0")} ${ampm}`;
}

export function hasAnyHours(hours) {
  if (!hours || typeof hours !== "object") return false;
  return DAYS_ORDER.some((key) => {
    const e = hours[key];
    return e && (e.closed || (e.open && e.close));
  });
}

// Returns { open: bool, label: string }
// Handles overnight shifts (close < open ⇒ close is next-day).
export function computeOpenStatus(hours) {
  if (!hasAnyHours(hours)) return { open: false, label: "" };
  const now = new Date();
  const todayIdx = now.getDay();
  const todayKey = JS_DAY_TO_KEY[todayIdx];
  const todayEntry = hours[todayKey];

  if (todayEntry && !todayEntry.closed && todayEntry.open && todayEntry.close) {
    const [oh, om] = todayEntry.open.split(":").map(Number);
    const [ch, cm] = todayEntry.close.split(":").map(Number);
    if (![oh, om, ch, cm].some(isNaN)) {
      const cur = now.getHours() * 60 + now.getMinutes();
      const opn = oh * 60 + om;
      let cls = ch * 60 + cm;
      if (cls <= opn) cls += 24 * 60;
      const curAdj = cur < opn ? cur + 24 * 60 : cur;
      if (curAdj >= opn && curAdj < cls) {
        return { open: true, label: `Open until ${formatTime(todayEntry.close)}` };
      }
      if (cur < opn) {
        return { open: false, label: `Closed until ${formatTime(todayEntry.open)}` };
      }
    }
  }

  // Find the next day with hours and report when they open.
  for (let i = 1; i <= 7; i++) {
    const key = JS_DAY_TO_KEY[(todayIdx + i) % 7];
    const e = hours[key];
    if (e && !e.closed && e.open) {
      const dayLabel = i === 1 ? "tomorrow" : DAY_LABEL[key];
      return { open: false, label: `Closed until ${formatTime(e.open)} ${dayLabel}` };
    }
  }
  return { open: false, label: "Closed" };
}
